import { Subject } from 'rxjs';
import { filter } from 'rxjs/operators';

const isLoading = new Subject();


export const loaderService = {
    onShowHide,
    show
}
// enable subscribing to show loader
function onShowHide() {
    return isLoading.asObservable();
}
// core alert method
function show(isShow) {
    isLoading.next(isShow);
}


